@if (radioButtons$ | async; as radioButtons) {
  <stb-radio-buttons
    [rebrand]="true"
    [horizontal]="false"
    [group]="radioButtons"
    (valueChanged)="updateFormFieldValue($event.value)"
  >
  </stb-radio-buttons>
}
